<template>
  <div>
    <stockorder
      :stockorders="stockOrders"
      :suppliers="supplierOrganisations"
      :devicemakemodels="deviceMakeModels"
      :stockitems="stockItems"
      :stocktypes="stockTypes"
      :couriers="couriers"
      :warehouses="warehouses"
      @stockOrderChange="getStockOrders()"
      :key="key"
    ></stockorder>
  </div>
</template>

<script>
import Api from "@/services/Api";
import StockOrder from "@/components/StockOrder.vue";

export default {
  components: {
    stockorder: StockOrder
  },
  data() {
    return {
      stockOrders: [],
      supplierOrganisations: [],
      deviceMakeModels: [],
      warehouses: [],
      stockTypes: [],
      stockItems: [],
      couriers: [],
      key: 0,
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
        this.getStockOrders();
        this.getWarehouses();
        this.getSupplierOrganisations();
        this.getDeviceMakeModels();
        this.getStockTypes();
        this.getStockItems();
        this.getAllCouriers();
        
    },
    getAllCouriers(){
      Api().get('/courier/allCouriers')
      .then(response=>{
        this.couriers=response.data.data.couriers
      })
    },
    getAllTrackingOrders(){
      Api()
      .get('/courier/trackingOrders')
      .then(async response=>{
        let trackings = response.data.data.trackings
        await trackings.map(x=>{
          let matchingOrder = this.stockOrders.find(y=>y.trackingNo===(x.tracking_number))
          let index = this.stockOrders.indexOf(matchingOrder)
          if(matchingOrder&&x.tag){
            this.updateStockOrder(matchingOrder, x.tag)
          }
          if(matchingOrder&&x.checkpoints){
              this.stockOrders[index].checkpoints = x.checkpoints.reverse()
            }
            // this.key +=1
        })
      })
    },
    updateStockOrder(item, status){
      Api()
      .put('/stockOrder/'+item.id,{
        orderStatus: status,
      })
      .then(()=>{
        let index = this.stockOrders.indexOf(item)
        item.orderStatus = status
        this.stockOrders[index]=item
      })
    },
    getStockOrders() {
      Api()
        .get("/stockOrder")
        .then(response => {
          this.stockOrders = response.data;
          // this.key +=1
          this.getAllTrackingOrders()
        });
    },
    getWarehouses(){
      Api()
        .get("/stockWarehouse")
        .then(response => {
          this.warehouses = response.data;
        });
    },
    getSupplierOrganisations() {
      Api()
        .get("/customer/organisation")
        .then(response => {
          this.supplierOrganisations = response.data;
        });
    },
    getDeviceMakeModels(){
      Api()
      .get('/deviceMakeModels/active')
      .then(response=>{
        this.deviceMakeModels=response.data
      })
    },
    getStockTypes(){
      Api().get('/stockType')
      .then(response=>{
        this.stockTypes=response.data
      })
    },
    getStockItems(){
      Api().get('/stockItem')
      .then(response=>{
        this.stockItems=response.data
      })
    }
  }
};
</script>

<style>
</style>